/**
 * Club-wide phrasing used everywhere a coach states preferences or makes a request —
 * one string so the booking sheet, matchday prompt and email landing page never drift.
 */
export const BEST_ENDEAVOURS_NOTE =
  "Requests are best endeavours only — we'll try to accommodate reasonable asks, never guaranteed.";

/** Shown beside every free-text preferences box — keeps personal data out of scheduling notes. */
export const PREFERENCES_PRIVACY_HINT =
  "Scheduling preferences only — please don't include personal or medical details.";
